import { FilterItemType } from '@otp/ui';
import { TFunction } from 'i18next';
import { StoresServerSideField } from 'src/components/common/stores/stores-serverside';
import { UsersServerSideField } from 'src/components/common/users/users-serverside';
import { IssueTicketImportance, Tag } from 'src/graphql/generated/graphql';

export const getFilterConfig = ({
  t,
  tags,
  size,
}: {
  t: TFunction;
  tags: Tag[];
  size: number;
}) => [
  {
    id: 'storeId',
    size,
    type: FilterItemType.Custom,
    render: (props: any) => (
      <StoresServerSideField {...props}></StoresServerSideField>
    ),
    props: {
      inputProps: {
        placeholder: t('columns.store'),
        name: 'storeId',
        label: t('columns.store'),
      },
    },
  },
  {
    id: 'importance',
    size,
    type: FilterItemType.Select,
    props: {
      inputProps: {
        placeholder: t('columns.importance'),
        name: 'importance',
        label: t('columns.importance'),
      },
      options: [
        {
          value: IssueTicketImportance.Low,
          name: t('columns.importance-low'),
        },
        {
          value: IssueTicketImportance.Medium,
          name: t('columns.importance-medium'),
        },
        {
          value: IssueTicketImportance.High,
          name: t('columns.importance-high'),
        },
      ],
    },
  },
  {
    id: 'tagId',
    size,
    type: FilterItemType.Select,
    props: {
      inputProps: {
        placeholder: t('columns.tag'),
        name: 'tagId',
        label: t('columns.tag'),
      },
      options: tags.map((tag) => ({
        value: tag.id,
        name: tag.name,
      })),
    },
  },
  {
    id: 'createdByUserId',
    size,
    type: FilterItemType.Custom,
    render: (props: any) => (
      <UsersServerSideField {...props}></UsersServerSideField>
    ),
    props: {
      inputProps: {
        placeholder: t('columns.created-by'),
        name: 'createdByUserId',
        label: t('columns.created-by'),
      },
    },
  },
  {
    id: 'assignedToUserId',
    size,
    type: FilterItemType.Custom,
    render: (props: any) => (
      <UsersServerSideField {...props}></UsersServerSideField>
    ),
    props: {
      inputProps: {
        placeholder: t('columns.assigned-to'),
        name: 'assignedToUserId',
        label: t('columns.assigned-to'),
      },
    },
  },
];
